import HealthemSpinner, { Spinner } from "@components/healthemSpinner/healthemSpinner";
import memberDetailsService from "@services/memberDetails.service";
import membersService from "@services/members.service";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import {
  CASE_STATUS_REASON_NOTE,
  CPSR_REPORT_CONTENT_INITIAL_STATE,
  DELETE,
  EDIT,
  KNOWMORE,
  PHYSICIAN_CARE_PLAN_NOTE,
  USER_ACTION_CARD_PHYSICIAN_CARE_PLAN,
  USER_ACTION_DESCRIPTION_CARE_PLAN_NOTE_SAVE,
  USER_ACTION_DESCRIPTION_CARE_PLAN_NOTE_UPDATE,
  USER_ACTION_LOCATION_CARE_PLAN_BUTTON,
  USER_ACTION_MODULE_MEMBER_DETAIL,
  USER_ACTION_TAB_CARE_MANAGEMENT,
  dateFormatConfig,
} from "@utils/constants";
import { formatDisplayDate, getClientName, getNoteMaxLength, milleniumClientCheck } from "@utils/helpers";
import { Collapse, Radio, Checkbox, Button, Spin, Select, DatePicker, notification, Empty, Switch, Row, Col , Popover, Tooltip , Typography} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { map, isEmpty, find, findIndex, cloneDeep, noop, get, set } from "lodash";
import moment from "moment";
import { useState, useEffect, useMemo, useRef } from "react";
import CarePlanReport from "../care-plan-report";
import CareCoordinationService from "@services/care-coordination";
import Icon from "@assets/icon_config";
import { appInsights, reactPlugin, withAITracking } from "../../../../../../appInsights";
import Referrals from "../care-team-referrals/referrals";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../../../constants/constants";
import { useProgramMetaData } from "@pages/member-details/care-coordination/customHooks";
import { CHECKBOX, OTHER, RADIO } from "@pages/member-details/care-coordination/constants";
import { CanEdit } from "@components/accessLevel";
import { NewNoteView } from "@pages/members/components/notePopup";
import { useHelperApiFunctions, usePatientData } from "@utils/customHooks";
import useSession from "@utils/useSession";
import './customisingTab.scss';
const { RangePicker } = DatePicker;
const { Panel } = Collapse;

const CarePlanReportCustomizationTab = ({ activeProgram }: any) => {
  const activeKeyForPhysicianCarePlan = useCareCoordinationStore((state) => state.activeKeyForPhysicianCarePlan);
  const setActiveKeyForPhysicianCarePlan = useCareCoordinationStore((state) => state.setActiveKeyForPhysicianCarePlan);
  const activekeyPhysicianCarePlanCondition = useCareCoordinationStore((state) => state.activekeyPhysicianCarePlanCondition);
  const setActivekeyPhysicianCarePlanCondition = useCareCoordinationStore((state) => state.setActivekeyPhysicianCarePlanCondition);
  const { patientId } = usePatientData();

  const {expandAllCards , defaultExpandedCards} = useMemo(() => {

    const clientName =  getClientName();
    const expandAllCards = clientName !== "Mycare" ? ['1' , '2' , '3'] : ['2']
    const defaultExpandedCards = clientName !== "Mycare" ? ["1"] : ["2"];

    return {expandAllCards , defaultExpandedCards}

  } ,[])


  useEffect(() => {
    appInsights.trackPageView({ name: "Care Plan Report" });
  }, []);

  useEffect(() => {
    if(activekeyPhysicianCarePlanCondition.from !== KNOWMORE) {
      setActiveKeyForPhysicianCarePlan(defaultExpandedCards);
    } else {
      setActivekeyPhysicianCarePlanCondition({});
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId]);

  const changeCollapse = () => {
    if(activeKeyForPhysicianCarePlan?.length > 0) {
      setActiveKeyForPhysicianCarePlan([])
    } else {
      setActiveKeyForPhysicianCarePlan(expandAllCards)
    }
  }

  return (
    <div className="ui-care-plan-customization-tab">
      <div className="member-detail-tab-header">
        <div className="member-detail-tab-header__collapse-all-button" onClick={changeCollapse}>
          <span className="member-detail-tab-header__collapse-all-button__title">{activeKeyForPhysicianCarePlan?.length > 0 ? "Collapse All" : "Expand All"}{" "}</span>
          <span className={`member-detail-tab-header__collapse-all-button__arrow ${activeKeyForPhysicianCarePlan?.length > 0 ? "" : "arrow-down"}`}>
            <Icon name={`${activeKeyForPhysicianCarePlan?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
          </span>
        </div>
      </div>
      {getClientName() !== "Mycare" && (
        <>
          <Referrals activeKey={activeKeyForPhysicianCarePlan} setActivePanels={setActiveKeyForPhysicianCarePlan} dataCardId={"3"} />
          <CarePlanSummary activeKey={activeKeyForPhysicianCarePlan} setActivePanels={setActiveKeyForPhysicianCarePlan} dataCardId={"1"} />
        </>
      )}
      <PhysicianCarePlan patientId={patientId} activeProgram={activeProgram} activeKey={activeKeyForPhysicianCarePlan} setActivePanels={setActiveKeyForPhysicianCarePlan} dataCardId={"2"} />
    </div>
  );
};

function CarePlanSummary({activeKey, setActivePanels, dataCardId }: any) {
  const [activeCardPanel, setActiveCardPanel] = useState<any[]>(activeKey?.includes(dataCardId) ? [dataCardId] : []);
  const {programTypeData } = useProgramMetaData({});

  // Care Plan Configuration related States
  const [notesSelection, setNotesSelection] = useState("MostRecentNotes");
  const [physicianNotesSelection, setPhysicianNotesSelection] = useState("MostRecentNotes");
  const [notesCategory, setNotesCategory] = useState("AllNotes");
  const [radioProgram, setRadioCareProgram] = useState<any>();
  const [checkboxPrograms, setCheckboxCarePrograms] = useState<any>([]);
  const [taskNotesSelection, setTaskNotesSelection] = useState<any>("MostRecentNotes");
  const [goalsCategory, setGoalsCategory] = useState<any>("AllGoals");
  const [goalsNotesCategory, setGoalsNotesCategory] = useState<any>("AllNotes");
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [showCustomReportContent, setShowCustomReportContent] = useState<any>(CPSR_REPORT_CONTENT_INITIAL_STATE);
  const [physicianNoteStartDate , setPhysicianNoteStartDate] = useState<any>();
  const [physicianNoteEndDate , setPhysicianNoteEndDate] = useState<any>();

  useEffect(() => {
    setActiveCardPanel(activeKey?.includes(dataCardId) ? [dataCardId] : []);
  }, [activeKey]);

  const disableGenerateReportBtn = () => {
    // when date range is selected for notes selection but date range is not selected generate report button will be disabled
    if (notesSelection === "DateRange" && (!startDate || !endDate)) {
      return true;
    }

    if (physicianNotesSelection === "DateRange" && (!physicianNoteStartDate || !physicianNoteEndDate)) {
      return true;
    }

    return false;
  };

  const onCollapseChange = () => {
    if (activeCardPanel.length > 0) {
      setActivePanels(cloneDeep(activeKey)?.filter((item: any) => item !== dataCardId));
    } else {
      setActivePanels([...(activeKey ? activeKey : []), dataCardId]);
    }
  };

  return (
    <>
      <Collapse accordion={true} activeKey={activeCardPanel} expandIconPosition="right" bordered={false} onChange={onCollapseChange}>
        <Panel className="ui-care-plan-customization-tab--panel1" header="Care Plan Summary" key={dataCardId} style={{ marginBottom: "16px" }}>
          <div className="ui-care-plan-customization-tab__heading">Patient Level Information</div>
          <div className="ui-care-plan-customization-tab__body">
            <div className="ui-care-plan-customization-tab__body__heading">Show Patient level Notes</div>
            <Switch
              checked={showCustomReportContent.patientLevelNotes}
              onChange={() => setShowCustomReportContent({ ...showCustomReportContent, patientLevelNotes: !showCustomReportContent.patientLevelNotes })}
            ></Switch>
            <div className="ui-care-plan-customization-tab__body__value">{showCustomReportContent.patientLevelNotes ? "Yes" : "No"}</div>
          </div>
          {showCustomReportContent.patientLevelNotes && (
            <>
              <div className="ui-care-plan-customization-tab__body">
                <div className="ui-care-plan-customization-tab__body__heading">Notes Selection</div>
                <Radio.Group
                  onChange={(e) => {
                    setNotesSelection(e.target.value);
                    if (e.target.value === "MostRecentNotes") {
                      setStartDate(undefined);
                      setEndDate(undefined);
                    }
                  }}
                  value={notesSelection}
                >
                  <Radio value={"MostRecentNotes"}>Most Recent Notes(5)</Radio>
                  <Radio value={"DateRange"}>Date range</Radio>
                </Radio.Group>

                {notesSelection === "DateRange" && (
                  <RangePicker
                    picker="date"
                    format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
                    allowClear={true}
                    dropdownClassName="reminder-picker"
                    ranges={{
                      "More Filters:": [null, null],
                      "Next 7 Days": [moment(), moment().add(7, "days")],
                      "Last 7 Days": [moment().subtract(7, "days"), moment()],
                    }}
                    onChange={(range: any) => {
                      setStartDate(range && range.length > 0 ? range[0]?.format("YYYY-MM-DD") : undefined);
                      setEndDate(range && range.length > 0 ? range[1]?.format("YYYY-MM-DD") : undefined);
                    }}
                    disabledDate={(current) => current && current.valueOf() > Date.now()}
                  />
                )}
              </div>
              <div className="ui-care-plan-customization-tab__body">
                <div className="ui-care-plan-customization-tab__body__heading">Notes Category</div>
                <Radio.Group onChange={(e) => setNotesCategory(e.target.value)} value={notesCategory}>
                  <Radio value={"AllNotes"}>All Notes</Radio>
                  <Radio value={"NotesToPCP"}>Notes to PCP</Radio>
                </Radio.Group>
              </div>
            </>
          )}

          <div className="ui-care-plan-customization-tab__heading">Care Program Level Information</div>
          <div className="ui-care-plan-customization-tab__body">
            <div className="ui-care-plan-customization-tab__body__heading">
              Select Care Programs <div className="ui-care-plan-customization-tab__body__heading--sub-heading">(Displays only the latest version of the Care Program)</div>
            </div>
            <div className="ui-care-plan-customization-tab__body__program">
              <Radio.Group
                options={programTypeData?.filter((r : any) => r.type === RADIO)?.sort((a: any, b: any) => a?.displayOrder - b?.displayOrder)}
                value={radioProgram}
                onChange={(e) => {
                  setRadioCareProgram(e.target.value);
                  setCheckboxCarePrograms([]);
                }}
              />
              {radioProgram === OTHER && (
                <Checkbox.Group
                  options={programTypeData?.sort((a: any, b: any) => a?.label.localeCompare(b?.label))?.filter((c : any) => c.type === CHECKBOX)}
                  value={checkboxPrograms}
                  onChange={(checkedValues) => setCheckboxCarePrograms(checkedValues)}
                />
              )}
            </div>
          </div>
          <div className="ui-care-plan-customization-tab__body">
            <div className="ui-care-plan-customization-tab__body__heading">Notes Selection / Category</div>
            <Radio.Group
              disabled={isEmpty([...checkboxPrograms, ...(radioProgram !== OTHER ? [radioProgram] : [])])}
              onChange={(e) => setTaskNotesSelection(e.target.value)}
              value={taskNotesSelection}
            >
              <Radio value={"MostRecentNotes"}>Most Recent Notes (5)</Radio>
              <Radio value={"NotesToPCP"}>Notes to PCP</Radio>
              <Radio value={"AllNotes"}>All Notes</Radio>
            </Radio.Group>
          </div>
          <div className="ui-care-plan-customization-tab__body">
            <div className="ui-care-plan-customization-tab__body__heading">Goals Selection / Category</div>
            <Radio.Group disabled={isEmpty([...checkboxPrograms, ...(radioProgram !== OTHER ? [radioProgram] : [])])} onChange={(e) => setGoalsCategory(e.target.value)} value={goalsCategory}>
              <Radio value={"AllGoals"}>All Goals</Radio>
              {/* <Radio value={"Report to PCP"}>Report to PCP</Radio> */}
            </Radio.Group>
          </div>
          <div className="ui-care-plan-customization-tab__body">
            <div className="ui-care-plan-customization-tab__body__heading">Goal Notes Category</div>
            <Radio.Group
              disabled={isEmpty([...checkboxPrograms, ...(radioProgram !== OTHER ? [radioProgram] : [])])}
              onChange={(e) => setGoalsNotesCategory(e.target.value)}
              value={goalsNotesCategory}
            >
              <Radio value={"AllNotes"}>All Notes</Radio>
              <Radio value={"NotesToPCP"}>Notes to PCP</Radio>
            </Radio.Group>
          </div>
          <div className="ui-care-plan-customization-tab__heading">Physician Care Plan</div>
          <div className="ui-care-plan-customization-tab__body">
            <div className="ui-care-plan-customization-tab__body__heading">Show Physician Care plan</div>
            <Switch
              checked={showCustomReportContent.physicianCarePlan}
              onChange={() => setShowCustomReportContent({ ...showCustomReportContent, physicianCarePlan: !showCustomReportContent.physicianCarePlan })}
            ></Switch>
            <div className="ui-care-plan-customization-tab__body__value">{showCustomReportContent.physicianCarePlan ? "Yes" : "No"}</div>
          </div>
          {showCustomReportContent.physicianCarePlan && (
            <>
              <div className="ui-care-plan-customization-tab__body">
                <div className="ui-care-plan-customization-tab__body__heading">Physician Care plan Selection</div>
                <Radio.Group
                  onChange={(e) => {
                    setPhysicianNotesSelection(e.target.value);
                    if (e.target.value === "MostRecentNotes") {
                      setPhysicianNoteStartDate(undefined);
                      setPhysicianNoteEndDate(undefined);
                    }
                  }}
                  value={physicianNotesSelection}
                >
                  <Radio value={"MostRecentNotes"}>Most Recent Notes(5)</Radio>
                  <Radio value={"DateRange"}>Date range</Radio>
                </Radio.Group>

                {physicianNotesSelection === "DateRange" && (
                  <RangePicker
                    picker="date"
                    format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
                    allowClear={true}
                    dropdownClassName="reminder-picker"
                    ranges={{
                      "More Filters:": [null, null],
                      "Next 7 Days": [moment(), moment().add(7, "days")],
                      "Last 7 Days": [moment().subtract(7, "days"), moment()],
                    }}
                    onChange={(range: any) => {
                      setPhysicianNoteStartDate(range && range.length > 0 ? range[0] : undefined);
                      setPhysicianNoteEndDate(range && range.length > 0 ? range[1] : undefined);
                    }}
                    disabledDate={(current) => current && current.valueOf() > Date.now()}
                  />
                )}
              </div>
            </>
          )}
          <div className="ui-care-plan-customization-tab__heading">Care Team</div>
          <div className="ui-care-plan-customization-tab__body">
            <div className="ui-care-plan-customization-tab__body__heading">Show Care Team Details</div>
            <Switch
              checked={showCustomReportContent.careTeamDetails}
              onChange={() => setShowCustomReportContent({ ...showCustomReportContent, careTeamDetails: !showCustomReportContent.careTeamDetails })}
            ></Switch>
            <div className="ui-care-plan-customization-tab__body__value">{showCustomReportContent.careTeamDetails ? "Yes" : "No"}</div>
          </div>
          <div className="ui-care-plan-customization-tab__footer">
            <Button
              type="text"
              className="ui-care-plan-customization-tab__footer__cancel-button"
              onClick={() => {
                setNotesSelection("MostRecentNotes");
                setPhysicianNotesSelection("MostRecentNotes");
                setCheckboxCarePrograms([]);
                setTaskNotesSelection("MostRecentNotes");
                setNotesCategory("AllNotes");
                setGoalsCategory("AllGoals");
                setGoalsNotesCategory("AllNotes");
                setStartDate(null);
                setEndDate(null);
                setPhysicianNoteStartDate(null);
                setPhysicianNoteEndDate(null);
                setRadioCareProgram(null);
                setShowCustomReportContent(CPSR_REPORT_CONTENT_INITIAL_STATE);
              }}
            >
              Reset
            </Button>
            <CarePlanReport
              payload={{
                notes: { notesSelection: notesSelection, notesCategory: notesCategory, startDate: startDate, endDate: endDate },
                physicianCarePlanNotes: { notesSelection: physicianNotesSelection, startDate: physicianNoteStartDate, endDate: physicianNoteEndDate },
                programGoalsCategory: goalsCategory,
                programGoalNotesSelection: goalsNotesCategory,
                programNotesCategory: taskNotesSelection,
                programs: map([...checkboxPrograms, ...(radioProgram && radioProgram !== OTHER ? [radioProgram] : [])], (item) => {
                  const program = find(programTypeData, { value: item });
                  return { programId: item, patientProgramId: program?.patientProgramId, name: program?.name, type: program?.type };
                }),
                display: showCustomReportContent,
              }}
              disableGenerateReportBtn={disableGenerateReportBtn}
            />
          </div>
        </Panel>
      </Collapse>
    </>
  );
}

function PhysicianCarePlan({ patientId, activeProgram, activeKey, setActivePanels, dataCardId }: any) {
  const [activeCardPanel, setActiveCardPanel] = useState<any[]>(activeKey?.includes(dataCardId) ? [dataCardId] : []);

  useEffect(() => {
    setActiveCardPanel(activeKey?.includes(dataCardId) ? [dataCardId] : []);
  }, [activeKey]);

  const onCollapseChange = () => {
    if (activeCardPanel.length > 0) {
      setActivePanels(cloneDeep(activeKey)?.filter((item: any) => item !== dataCardId));
    } else {
      setActivePanels([...(activeKey ? activeKey : []), dataCardId]);
    }
  };  
  const [description, setDescription] = useState<string>("");

  const [loading , setLoading] = useState<boolean>(false);

  const physicianCarePlanNotes = useCareCoordinationStore((state) => state.physicianCarePlanNotes);
  const setPhysicianCarePlanNotes = useCareCoordinationStore((state) => state.setPhysicianCarePlanNotes);

  const [dateRange , setDateRange] = useState([]);

  const session = useSession();

  const noteType = PHYSICIAN_CARE_PLAN_NOTE;

  const isBookmarked = false;

  const recipientType = '';

  function addNote(callback = noop) {
    membersService.addNotes([patientId], description, noteType , isBookmarked , recipientType).subscribe({
      next: (res) => {
        const newNote = {
          notesId: get(res , 'data.data.note[0].noteId' , ''),
          notes : description,
          notesCreateDate : moment.utc(),
          isBookMarked : isBookmarked,
          patientId : patientId,
          patientName : "",
          careManagerId : get(session , 'user.id' ,''),
          noteType : noteType,
          careMgrFirstName : get(session , 'user.firstName' ,''),
          careMgrLastName : get(session , 'user.lastName' ,''),
          recipientType : recipientType
        };

        setLoading(false);
        callback();
        setDescription('');
        setPhysicianCarePlanNotes([newNote , ...physicianCarePlanNotes])
      },
      error: () => {
        setLoading(false);
        callback();
        setDescription('');
      },
    });
  }

  function editNote(callback = noop , notesId : string) {
    membersService.editNotes(notesId, patientId, description, false, '', false).subscribe({
      next: (res) => {
        const data = cloneDeep(physicianCarePlanNotes);

        const updatedNote = find(data , (n) => n.notesId === notesId);

        set(updatedNote ,'notes' , description);
        set(updatedNote ,'notesCreateDate' , moment.utc());

        setPhysicianCarePlanNotes(data);
        setLoading(false);
        callback();
      },
      error: (e) => {
        console.log(e);
        setLoading(false);
        callback();
      },
    });
  }

  function updateNotesOnDelete(noteId : any) {
    setPhysicianCarePlanNotes(physicianCarePlanNotes.filter((n : any) => n.notesId !== noteId));
  }

  function handleOk(e: any , viewType : string, callback = noop , notesId = '') {
    e.stopPropagation();
    setLoading(true);
    if(viewType === 'Add') {
      addNote(callback);
    } else if(viewType === 'Update') {
      editNote(callback , notesId);
    }
  }

  function handleCancel(e: any) {
    e.stopPropagation();
    setDescription('');
  }

  function handleDateChange(range: any) {
    setDateRange(range);
  }

  function updateShowMore(id : number) {
    let notes = cloneDeep(physicianCarePlanNotes);
    const noteToUpdate : any = find(notes , (n) => n.notesId === id);
  
    set(noteToUpdate , 'isShowMore' , !noteToUpdate.isShowMore);

    setPhysicianCarePlanNotes(notes);
  }

  const notesData = useMemo(() => {
    let startDate = get(dateRange, "[0]", "");
    let endDate = get(dateRange, "[1]", "");

    return physicianCarePlanNotes.filter((n : any) => {
      if(startDate && endDate) {
        return moment(n.notesCreateDate).isSameOrAfter(startDate.startOf("day")) && moment(n.notesCreateDate).isSameOrBefore(endDate.endOf("day"));
      } 
      
      return true
    })
  } , [dateRange, physicianCarePlanNotes])


  return (
    <Collapse accordion={true} activeKey={activeCardPanel} expandIconPosition="right" bordered={false} onChange={onCollapseChange}>
      <Panel header={<PhysicainCarePlanHeader {...{loading, handleOk, handleCancel, description, setDescription , dateRange , handleDateChange }} />} key={dataCardId}>
        <PhysicanCarePlanBody {...{ patientId, notesData: notesData, activeProgram, loading, handleOk, handleCancel, description, setDescription , updateShowMore , updateNotesOnDelete}} />
      </Panel>
    </Collapse>
  );
}

function PhysicainCarePlanHeader({loading, handleOk, handleCancel, description, setDescription , dateRange , handleDateChange} : any) {

  const [isPopOverVisible, setIsPopOverVisible] = useState<boolean>(false);

  const viewType = 'Add';

  function handleOkClick(e : any) {
    handleOk(e , viewType , () => {
      setIsPopOverVisible(!isPopOverVisible);
    });
  } 

  function handleIconClick(e: any) {
    e.stopPropagation();
    setIsPopOverVisible(!isPopOverVisible);
  }

  function handleCancelClick(e : any) {
    setIsPopOverVisible(!isPopOverVisible);
    handleCancel(e);
  }

  const isMillenium = milleniumClientCheck();

  return (
    <div className="physician_care_plan-header-wrapper flex v-center">
      <h4 className="physician_care_plan-panel-title">Physician Care Plan</h4>
      {isMillenium ? <div className="ml-auto d-flex d-flex--center">
      <DateRangeFilter dateRange ={dateRange} handleDateChange={handleDateChange}/>
        <NotePopOver {...{ viewType, loading, handleOk : handleOkClick, handleCancel : handleCancelClick, description, setDescription, isPopOverVisible}}>
          <CanEdit>
            <Button className="ml-auto" title="Add" type="text" onClick={(e) => handleIconClick(e)}>
              <Icon name="add" height="24" width="24" />
            </Button>
          </CanEdit>
        </NotePopOver>
      </div> : <></>}
    </div>
  );
}

function PhysicanCarePlanBody({ patientId, activeProgram , notesData , loading, handleOk, handleCancel, description, setDescription, handleIconClick , updateShowMore , updateNotesOnDelete}: any) {


  if (milleniumClientCheck()) {
    return <NotesList {...{ notesData , loading, handleOk, handleCancel, description, setDescription, handleIconClick , updateShowMore , updateNotesOnDelete}} />;
  } else {
    return <CarePlanFromEMRSystem {...{ patientId, activeProgram }} />;
  }
}

function DateRangeFilter({ dateRange, handleDateChange }: any) {
  return (
    <div className="reminderDatePicker" onClick={(e) => e.stopPropagation()}>
      <div className="reminderDateLabel">
        <span className="icon-calendar f18" />
        <span>Date Range : </span>
      </div>
      <RangePicker
        value={dateRange}
        picker="date"
        format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
        allowClear={true}
        dropdownClassName="filter-date-picker"
        ranges={{
          Today: [moment().startOf('day'), moment().endOf('day')],
          Yesterday: [moment().subtract(1, "days").startOf('day'), moment().subtract(1, "days").endOf('day')],
          "Last 2 days": [moment().subtract(2, "days").startOf('day'), moment().endOf('day')],
          "Last 7 days": [moment().subtract(7, "days").startOf('day'), moment().endOf('day')],
        }}
        onChange={(range: any) => {
          handleDateChange(range);
        }}
        disabledDate={(current) => current && current >= moment().add(1, 'day').startOf('day')}
      />
    </div>
  );
}

function NotesList({ notesData, loading, handleOk, handleCancel, description , setDescription , updateShowMore , updateNotesOnDelete}: any) {

  const session = useSession();

  const viewType = 'Update';

  return (
    <div className="physician-note-list-container custom-scroll-bar">
      {!notesData?.length && <DataNotFound message={NO_DATA_FOUND} />}
      {notesData?.map((item: any) => {
        const isLoggedInUser = item.careManagerId === session?.user?.id;
        const allowedTags = ["strong", "u", "em", "a"];
        const sanitizedContent = item.notes.replace(/<[^>]+>/g, (t: any) => {
          const tag = t.match(/<\/?(\w+)/);
          if (tag && allowedTags.includes(tag[1])) {
            return t;
          } else {
            return "";
          }
        });
        return (
          <NoteCard {...{isLoggedInUser , item , viewType , loading , handleOk , handleCancel , description , sanitizedContent, setDescription , updateShowMore , updateNotesOnDelete}}/>
        );
      })}
    </div>
  );
}

function NoteCard({isLoggedInUser , item , viewType ,loading , handleOk , handleCancel , description,sanitizedContent , setDescription , updateShowMore , updateNotesOnDelete} : any) {

  const [isPopOverVisible, setIsPopOverVisible] = useState<boolean>(false);

  const [contentHeight, setContentHeight] = useState(0);

  const {deleteNotes , noteDeleteLoader} = useHelperApiFunctions();
 
  useEffect(
    () => {
      setTimeout(
        () => {
          setContentHeight(content.current?.scrollHeight || 0)
        },
        50
      )
    },
    [sanitizedContent]
  )

  function handleIconClick(e: any , action : string , data ?: any) {
    e.stopPropagation();
    if(action === EDIT) {
      setIsPopOverVisible(!isPopOverVisible);
      if(!isPopOverVisible){
        setDescription(sanitizedContent);
      }
    } else if(action === DELETE) {
        deleteNotes({noteId : data.noteId , successCallback: updateNotesOnDelete(data.noteId)});
    }
  }

  function handleOkClick(e : any) {
    handleOk(e , viewType , () => {
      setIsPopOverVisible(!isPopOverVisible);
    } , item.notesId);
  } 

  function handleCancelClick(e : any) {
    setIsPopOverVisible(!isPopOverVisible);
    handleCancel(e);
  }

  const content = useRef<HTMLDivElement>(null)

  const toggleShowMore = () => {
    if (content.current) {
      content.current.scrollTop = 0
    }
    updateShowMore(item.notesId);
  }

  const noteItem: any = <div dangerouslySetInnerHTML={{ __html: sanitizedContent }}></div>;

  return (
    <div className={`physician-note-body ${!isLoggedInUser ? "grey-background" : ""} ${item.isShowMore ? "" : "showless"}`} key={item.notesId}>
      <div className="physician-note-sub-content">
        <span className="physician-note-time">
          {item.careMgrFirstName} {item.careMgrLastName} | {formatDisplayDate(item.notesCreateDate, "reminderDateActualFormat", "defaultDateFormatWithTimeWithPipe", true)}
        </span>
        <div className="physician-note-content__note-edit-fields">
          {isLoggedInUser && (
            <NotePopOver {...{ viewType, loading, handleOk: handleOkClick, handleCancel: handleCancelClick, description, setDescription, isPopOverVisible }}>
              <CanEdit>
                <div
                  className={`icon-edit f18  clr-blueLink pointer`}
                  onClick={(e) => {
                    handleIconClick(e, EDIT);
                  }}
                />
                <Spinner loading={noteDeleteLoader} indicator={<HealthemSpinner />}>
                  <div
                    className={`icon-delete f18 clr-e100 pointer`}
                    onClick={(e) => {
                      handleIconClick(e, DELETE, { noteId: item.notesId });
                    }}
                  />
                </Spinner>
              </CanEdit>
            </NotePopOver>
          )}
        </div>
      </div>
      <div className="physician-note-content">
        <div className={`noteContent custom-scroll-bar notes-html ${item.isShowMore ? "more" : "less"}`} ref={content}>
          {noteItem}
        </div>
      </div>
      {contentHeight > 40 && (
        <div className="noteContent__showMoreLink" onClick={() => toggleShowMore()}>
          {item.isShowMore ? "less" : "more"}
        </div>
      )}
    </div>
  );
}

function CarePlanFromEMRSystem({ patientId, activeProgram }: any) {

  const [dropDownData, setDropDownData] = useState<any>();

  // EMR Noted related State
  const [loading, setLoading] = useState<any>();

  const [response, setResponse] = useState<any>({});
  const [showAddButton, setShowAddButton] = useState<any>(false);
  const [action, setAction] = useState<any>("Add");

  const initialResponse = useCareCoordinationStore((state) => state.initialResponse);
  const setInitialResponse = useCareCoordinationStore((state) => state.setInitialResponse);

  useEffect(() => {
    if (activeProgram.toString() === "care-plan-config") {
      setLoading(true);

      if (!patientId) {
        return;
      }

      CareCoordinationService.fetchCarePlanEMRNotes({ patientId: patientId }).subscribe({
        next: (v: any) => {
          const _response = v.data.data;
          setInitialResponse(_response);
          setShowAddButton(isEmpty(_response));
          setAction(isEmpty(_response) ? "Add" : "Update");
          setResponse(_response);
          setLoading(false);
        },
        error: (e) => {
          console.log(e);
          setLoading(false);
        },
      });
    }
  }, [activeProgram]);

  useEffect(() => {
    memberDetailsService.fetchCaseStatusActiveDropdown("PcpNameLst").subscribe({
      next: (response: any) => {
        setDropDownData(response.data.data.data);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }, []);

  const addUpdateEmrNote = (payload: any) => {
    CareCoordinationService.addUpdateEmrNote(payload).subscribe({
      next: (v: any) => {
        setResponse({ ...response, noteId: v?.data?.data?.noteId, last_updated_date: moment() });
        setInitialResponse({ ...response, noteId: v?.data?.data?.noteId, last_updated_date: moment() });
        setLoading(false);
        if (action === "Add") {
          setShowAddButton(false);
          setAction("Update");
        }
      },
      error: (error) => {
        console.log(error);
        setLoading(false);
      },
    });
    if (payload.isUpdate) {
      const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(
        USER_ACTION_DESCRIPTION_CARE_PLAN_NOTE_UPDATE,
        CASE_STATUS_REASON_NOTE
      );
      membersService.updateStatus(patientId, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
        next: (v) => {
          console.log("updated status successfully");
        },
        error: (e) => {
          console.log("update status failed");
        },
      });
    } else {
      const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(USER_ACTION_DESCRIPTION_CARE_PLAN_NOTE_SAVE, CASE_STATUS_REASON_NOTE);
      membersService.updateStatus(patientId, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
        next: (v) => {
          console.log("updated status successfully");
        },
        error: (e) => {
          console.log("update status failed");
        },
      });
    }
  };

  const getUserActionParams = (userActionDescription: any, reason: any) => {
    let props = {
      caseStatusReasonTxt: reason,
      actionModule: USER_ACTION_MODULE_MEMBER_DETAIL,
      actionTab: USER_ACTION_TAB_CARE_MANAGEMENT,
      actionCard: USER_ACTION_CARD_PHYSICIAN_CARE_PLAN,
      actionLocation: USER_ACTION_LOCATION_CARE_PLAN_BUTTON,
      actionDescription: userActionDescription,
    };
    return props;
  };

  return (
    <Spin spinning={loading} indicator={<HealthemSpinner />}>
      <div className="ui-care-plan-customization-tab__physician-care-plan">
        <div className="ui-care-plan-customization-tab__physician-care-plan__header">
          <div className="ui-care-plan-customization-tab__physician-care-plan__header__heading">Care Plan From EMR System</div>
          {isEmpty(response) && showAddButton && (
            <div className="ui-care-plan-customization-tab__physician-care-plan__header__add" onClick={() => setShowAddButton(false)}>
              <Icon name="add" height={"24"} width={"24"} />
            </div>
          )}
        </div>

        {isEmpty(response) && showAddButton && <DataNotFound message={NO_DATA_FOUND} />}

        {!showAddButton && (
          <>
            <div className="ui-care-plan-customization-tab__physician-care-plan__sub-header">
              <Select
                className="ui-care-plan-customization-tab__physician-care-plan__sub-header__pcp"
                size="large"
                placeholder="Select Physician"
                value={response?.pcp_name}
                style={{ width: 240 }}
                options={dropDownData}
                onChange={(val) => setResponse({ ...response, pcp_name: val })}
                showSearch
              />
              <DatePicker
                style={{ width: 240 }}
                value={response?.physician_care_plan_date ? moment(response?.physician_care_plan_date) : null}
                onChange={(date: any, val: any) => {
                  setResponse({ ...response, physician_care_plan_date: val });
                }}
                format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
                size={"large"}
                disabledDate={(current) => current && current.valueOf() > Date.now()}
              />
            </div>

            <TextArea
              rows={5}
              value={response?.careplan_note_description}
              style={{ resize: "none" }}
              placeholder="Write your text here..."
              maxLength={getNoteMaxLength()}
              showCount
              onChange={(e) => setResponse({ ...response, careplan_note_description: e.target.value })}
            />
            {response?.last_updated_date && (
              <div className="ui-care-plan-customization-tab__physician-care-plan__last-updated-on">
                Last Updated On {moment(response?.last_updated_date)?.format(dateFormatConfig.get(getClientName())["defaultDateFormatWithTimeWithPipe"])}
              </div>
            )}
            {((action === "Update" &&
              (response?.careplan_note_description !== initialResponse?.careplan_note_description ||
                response?.pcp_name !== initialResponse?.pcp_name ||
                response?.physician_care_plan_date !== initialResponse?.physician_care_plan_date)) ||
              action === "Add") && (
              <div className="ui-care-plan-customization-tab__physician-care-plan__footer">
                <Button
                  onClick={() => {
                    if (action === "Add") {
                      setResponse({});
                      setShowAddButton(true);
                    }
                    if (action === "Update") {
                      setResponse(initialResponse);
                    }
                  }}
                  type="text"
                  className="ui-care-plan-customization-tab__footer__cancel-button"
                >
                  Cancel
                </Button>
                {action === "Add" ? (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (isEmpty(response?.physician_care_plan_date) || isEmpty(response?.careplan_note_description) || isEmpty(response?.pcp_name)) {
                        notification.error({
                          message: "Please select all the required fields.",
                        });
                        return;
                      }
                      setLoading(true);
                      addUpdateEmrNote({
                        noteDate: response?.physician_care_plan_date,
                        description: response?.careplan_note_description,
                        pcpNPI: find(dropDownData, { value: response?.pcp_name })?.key,
                        noteId: null,
                        patientId: patientId,
                        isUpdate: false,
                      });
                    }}
                    disabled={!(response?.physician_care_plan_date && response?.careplan_note_description && response?.pcp_name)}
                  >
                    Save
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (isEmpty(response?.physician_care_plan_date) || isEmpty(response?.careplan_note_description) || isEmpty(response?.pcp_name)) {
                        notification.error({
                          message: "Please select all the required fields.",
                        });
                        return;
                      }
                      setLoading(true);
                      addUpdateEmrNote({
                        noteDate: response?.physician_care_plan_date,
                        description: response?.careplan_note_description,
                        pcpNPI: find(dropDownData, { value: response?.pcp_name })?.key,
                        noteId: response?.noteId,
                        patientId: patientId,
                        isUpdate: true,
                      });
                    }}
                  >
                    Update
                  </Button>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </Spin>
  );
}

function NotePopOver({ viewType , loading ,handleOk ,handleCancel ,description ,setDescription ,  isPopOverVisible ,children}: any) {

  
  return (
    <Popover
      trigger="click"
      overlayClassName="notesPopoverOverlay"
      open={isPopOverVisible}
      content={<NewNoteView viewType={viewType} loading={loading} handleOk={handleOk} description={description} setDescription={setDescription} handleCancel={handleCancel} showCustomControls={false} />}
      placement="left"
      destroyTooltipOnHide={true}
    >
      {children}
    </Popover>
  );
}

export default withAITracking(reactPlugin, CarePlanReportCustomizationTab);
